import { Form, Input, Modal, Row, Space } from "antd";
import React, { useState } from "react";
import AtomPrimaryButton from "../../button/primary-button";
import AtomSecondaryButton from "../../button/secondary-button";

const UpdateEmailModal = ({ open, setOpen, isSubmit, onFinish }) => {
  const [input, setInput] = useState({ email: "", password: "" });

  const handleChange = (e) => {
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  return (
    <Modal
      title="Edit Email"
      centered
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <Form
        name="update-email"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          style={{
            fontWeight: 500,
            lineHeight: "150%",
            color: "#212529",
          }}
          label="New Email"
          name="email"
          rules={[
            { type: "email" },
            {
              required: true,
              message: "Please input your new email!",
            },
          ]}
        >
          <Input
            size="large"
            name="email"
            autoFocus={true}
            placeholder="Input your new email"
            onChange={(e) => handleChange(e)}
          />
        </Form.Item>

        <Form.Item
          style={{
            fontWeight: 500,
            lineHeight: "150%",
            color: "#212529",
          }}
          label="Your Password"
          name="password"
          rules={[
            {
              required: true,
              message: "Please input your account password!",
            },
          ]}
        >
          <Input.Password
            size="large"
            name="password"
            placeholder="Input your account password"
            onChange={(e) => handleChange(e)}
          />
        </Form.Item>

        <Row justify="center">
          <Space size="middle">
            <AtomPrimaryButton
              loading={isSubmit}
              disabled={input.email === "" || input.password === ""}
              htmlType="submit"
            >
              Save Changes
            </AtomPrimaryButton>

            <AtomSecondaryButton onClick={() => setOpen(false)}>
              Cancel
            </AtomSecondaryButton>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateEmailModal;
